import React from "react";
import DashboardDropdown, {
  type DashboardDropdownGroup,
} from "@/ReactInit/Scripts/DashboardPage/components/DashboardDropdown";
import {getSelectableReportYears} from "@/ReactInit/Scripts/DashboardPage/utils/reportYears";

type Props = {
  value: number;
  onChange: (year: number) => void;
  disabled?: boolean;
  yearsBack?: number;
  label?: string;
  disabledYears?: number[];
  disabledYearReason?: string;
};

export default function DashboardReportYearSelector(
  {
    value,
    onChange,
    disabled,
    yearsBack = 8,
    label = "År",
    disabledYears = [],
    disabledYearReason = "Det finnes allerede en rapport for dette året.",
  }: Props) {
  const years = getSelectableReportYears(new Date(), yearsBack);
  const disabledSet = new Set(disabledYears);

  const groups: DashboardDropdownGroup[] = [
    {
      items: years.map((y) => ({
        value: String(y),
        label: String(y),
        disabled: disabledSet.has(y),
        disabledReason: disabledSet.has(y) ? disabledYearReason : undefined,
      })),
    },
  ];

  return (
    <DashboardDropdown
      groups={groups}
      selectedValues={[String(value)]}
      onChange={(values) => {
        const raw = values[0];
        const next = raw ? Number(raw) : value;
        if (!Number.isNaN(next)) onChange(next);
      }}
      label={label}
      disabled={disabled}
      placeholder={String(value)}
    />
  );
}
